import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MunicionRecomendadaComponent } from 'src/app/newComponents/municion-recomendada/municion-recomendada.component';
import { MyDataService } from 'src/app/services/data/data.service';
import { DiagnosisService } from 'src/app/services/diagnosis/diagnosis.service';
import { MailService } from 'src/app/services/mail/mail.service';
import { SnackBarService } from 'src/app/services/snackBar/snack-bar.service';
import { TicketsService } from 'src/app/services/tickets/tickets.service';
import { environment } from 'src/environments/environment';
import { PhotoCaptureComponent } from './photo-capture/photo-capture.component';

@Component({
  selector: 'app-nuevo-caso',
  templateUrl: './nuevo-caso.component.html',
  styleUrls: ['./nuevo-caso.component.scss'],
})
export class NuevoCasoComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('numSerie2Input') numSerie2Input!: ElementRef;
  @ViewChild('numSerie3Input') numSerie3Input!: ElementRef;
  @ViewChild('numSerie4Input') numSerie4Input!: ElementRef;

  private destroyed$ = new Subject<void>();

  public formProducto: FormGroup;

  step: 1 | 2 | 3 | 4 | 5 = 1;

  productoSelected: any = undefined;

  activoSelected: any = undefined;

  distribuidoresSubproyectos: any = [];
  distribuidoresSubproyectosTemp: any = [];

  user: any = null;

  categories: any = [];

  pasosCategory: any = [];

  newTicket: any = null;

  motivo = false;

  reciboCompraImage: string | null = null;

  adjuntos: any = [];

  adjuntosExtra = [];

  symptonCodes: any = [];

  sectionCodes: any = [];

  selectedSintoma: any = null;

  selectedSection: any = null;

  logo: any;

  loadingCrearTicket: boolean = false;

  busquedaDistribuidor: string = '';

  project: any = null;

  activeLang: string = 'es';

  constructor(
    private router: Router,
    private _formBuilder: FormBuilder,
    private ticketsSvc: TicketsService,
    private dataSvc: MyDataService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
    private diagnosisService: DiagnosisService,
    private mailService: MailService,
    private translocoService: TranslocoService
  ) {
    this.formProducto = this._formBuilder.group({
      numserie1: ['', [Validators.required, Validators.maxLength(250)]],
      numserie2: ['', [Validators.required, Validators.maxLength(250)]],
      numserie3: ['', [Validators.required, Validators.maxLength(250)]],
      numserie4: ['', [Validators.required, Validators.maxLength(250)]],
      fechaCompra: ['', []],
      distribuidor: ['', []],
      categoria: ['', []],
      motivo: ['', [Validators.required, Validators.maxLength(250)]],
      imagenes: [[]],
    });
  }

  ngOnInit(): void {
    const logo = this.dataSvc.getLogo();
    if (logo) {
      this.logo = logo;
      console.log(this.logo);
    } else {
      this.dataSvc.getLogoObservable().subscribe((value) => {
        this.logo = value;
        console.log(this.logo);
      });
    }
    const proyectoPlatform = this.dataSvc.getFkEntityPlatform();
    const user = this.dataSvc.getUserPlatform();
    if (user) {
      this.user = user;
      console.log(this.user);
      if (this.user && this.project) {
        this.getTicketsClienteHoy();
      }
    } else {
      this.dataSvc.getUserObservable().subscribe((value) => {
        this.user = value;
        console.log(this.user);
        if (this.user && this.project) {
          this.getTicketsClienteHoy();
        }
      });
    }
    if (proyectoPlatform) {
      this.project = proyectoPlatform;
      this.getSymptonCodes(proyectoPlatform);
      this.getSectionCodes(proyectoPlatform);
      if (this.user && this.project) {
        this.getTicketsClienteHoy();
      }
    } else {
      this.dataSvc.getFkEntityPlatformObservable().subscribe((value) => {
        this.project = value;
        this.getSymptonCodes(value);
        this.getSectionCodes(value);
        if (this.user && this.project) {
          this.getTicketsClienteHoy();
        }
      });
    }

    this.formProducto.get('numserie1')?.valueChanges.subscribe((value) => {
      if (value.length === 2) {
        document.getElementById('numSerie2')?.focus();
      }
    });

    this.formProducto.get('numserie2')?.valueChanges.subscribe((value) => {
      if (value.length === 2) {
        document.getElementById('numSerie3')?.focus();
      }
    });

    this.formProducto.get('numserie3')?.valueChanges.subscribe((value) => {
      if (value.length === 6) {
        document.getElementById('numSerie4')?.focus();
      }
    });

    this.activeLang = this.translocoService.getActiveLang();
    this.translocoService.langChanges$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((newLang) => {
        this.activeLang = newLang;
      });
  }

  ngAfterViewInit(): void {
    // Manejar el cambio de foco automáticamente
    this.formProducto.get('numserie1')!.valueChanges.subscribe((value) => {
      if (value.length === 2) {
        this.numSerie2Input.nativeElement.focus();
      }
    });

    this.formProducto.get('numserie2')!.valueChanges.subscribe((value) => {
      if (value.length === 2) {
        this.numSerie3Input.nativeElement.focus();
      }
    });

    this.formProducto.get('numserie3')!.valueChanges.subscribe((value) => {
      if (value.length === 6) {
        this.numSerie4Input.nativeElement.focus();
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  buscarDistribuidor(event: any): void {
    // Convierte el término de búsqueda a minúsculas para hacer la búsqueda sin distinción entre mayúsculas y minúsculas
    const busqueda = event?.target?.value.toLowerCase();

    console.log(busqueda);

    // Filtra la lista de distribuidores en función del término de búsqueda
    this.distribuidoresSubproyectos =
      this.distribuidoresSubproyectosTemp.filter((distribuidor: any) =>
        distribuidor.proyecto_name.toLowerCase().includes(busqueda)
      );

    console.log(this.distribuidoresSubproyectos);
  }

  showSnackBarError(mensaje: string) {
    this.snackBarService.openSnackBarError(mensaje);
  }

  siguientePaso() {
    if (this.step === 1) {
      this.step = 2;
    } else if (this.step === 2) {
      this.step = 3;
    } else if (this.step === 3) {
      this.step = 4;
    }

    console.log({ step: this.step });
  }

  deleteItemListMultimedia(adjunto: any) {
    this.adjuntos = this.adjuntos.filter((ad: any) => ad !== adjunto);
  }

  problemaNoSolucionado() {
    this.step = 4;
  }

  codesSelection(code: any, mode: string) {
    if (mode === 'sintoma') {
      this.selectedSintoma = code;
      this.step = 3;
      if (code) {
        this.getPasos();
      }
    } else if (mode === 'seccion') {
      this.selectedSection = code;
      this.step = 4;
    }
  }

  async getImagenPaso(idPaso: number, idImagen: number) {
    this.diagnosisService
      .getImagePasoCode(idPaso, idImagen)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res: any) => {
          console.log('Imagen descargada.');
          console.log(res);
          for (const seccion of this.pasosCategory) {
            for (const paso of seccion.pasos) {
              for (const imagen of paso.imagenes) {
                if (idImagen === imagen.ID) {
                  imagen.base64 = res.base64;
                }
              }
            }
          }
        },
        error: (e: any) => {},
      });
  }

  getPasos() {
    this.ticketsSvc
      .getCategoriesPasos(this.selectedSintoma.ID)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res) => {
          console.log(res);
          this.pasosCategory = res.pasos;

          for (const seccion of res.pasos) {
            for (const paso of seccion.pasos) {
              for (const imagen of paso.imagenes) {
                this.getImagenPaso(paso.id, imagen.ID);
              }
            }
          }
        },
        error: (e) => {
          this.router.navigate(['/casos']);
        },
      });
  }

  crearTicket(status: string) {
    const data = {
      FK_entities:
        this.activoSelected?.almacen?.almacenes_proyectos[0]?.id_proyecto,
      name:
        this.activoSelected.serial +
        ' - ' +
        this.user?.cliente?.nombre +
        ' ' +
        this.user?.cliente?.apellido,
      contents: this.formProducto.get('motivo')?.value ?? '',
      numserie: this.activoSelected.serial,
      tipoDispositivo: this.productoSelected.dispositivo,
      marca_id: this.productoSelected.marca,
      modelo_id: this.productoSelected.modelo,
      pn: this.productoSelected.PN,
      assign: 0,
      assign_ent: 0,
      clienteSolicitante: this?.user?.cliente.ID,
      fk_elemento_almacen: this.activoSelected.id,
      status: status,
    };
    this.loadingCrearTicket = true;
    this.ticketsSvc
      .crearTicket(data)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (v) => {
          console.log(v);
          this.loadingCrearTicket = false;
          this.newTicket = v.ticket;
          if (status !== 'old_done') {
            this.step = 5;
          } else {
            this.router.navigate(['/casos']);
          }
          if (status !== 'old_done') {
            this.mailService
              .sendMailConfirmacion(
                this.user?.cliente?.email_contacto,
                this.newTicket.ID,
                this.activoSelected.serial,
                this.user?.cliente?.nombre + ' ' + this.user?.cliente?.apellido,
                this.logo
              )
              .pipe(takeUntil(this.destroyed$))
              .subscribe({
                next: (res: any) => {
                  console.log(res);
                },
                error: (e: any) => {
                  this.showSnackBarError(
                    this.translocoService.translate(
                      'issue.error.confirmationEmail'
                    )
                  );
                },
              });
          }
          this.diagnosisService
            .createDiagnosis(
              'Diagnosis area de clientes',
              data.contents,
              this.selectedSintoma ? this.selectedSintoma.ID : null,
              this.selectedSection ? this.selectedSection.ID : null,
              this.newTicket.ID,
              data.numserie
            )
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
              next: (res: any) => {},
              error: (e: any) => {
                this.showSnackBarError(
                  this.translocoService.translate('issue.error.createDiagnosis')
                );
              },
            });
          if (this.reciboCompraImage) {
            this.ticketsSvc
              .uploadAdjunto(
                v.ticket.ID,
                6,
                'ticketcompra-' + v.ticket.ID + '.jpeg',
                this.reciboCompraImage
              )
              .pipe(takeUntil(this.destroyed$))
              .subscribe(
                (data3) => {
                  console.log('Data file upload', data3);
                },
                (err) => {
                  console.log(err);
                  this.loadingCrearTicket = false;
                  this.showSnackBarError(
                    this.translocoService.translate(
                      'issue.error.uploadPurchaseTicket'
                    )
                  );
                }
              );
          }
          for (const adjunto of this.adjuntos) {
            this.ticketsSvc
              .uploadAdjunto(
                v.ticket.ID,
                adjunto.type === 'video' ? 1 : 6,
                adjunto.name,
                adjunto.base64
              )
              .pipe(takeUntil(this.destroyed$))
              .subscribe(
                (data2) => {
                  console.log('Data file upload', data2);
                },
                (err) => {
                  console.log(err);
                  this.showSnackBarError(
                    this.translocoService.translate(
                      'issue.error.uploadAttachment'
                    )
                  );
                }
              );
          }
        },
        error: (e) => {
          this.router.navigate(['/casos']);
          this.showSnackBarError(
            this.translocoService.translate('issue.error.createTicket')
          );
        },
      });
  }

  openMunicionRecomendada() {
    const dialogRef = this.dialog.open(MunicionRecomendadaComponent, {
      data: {},
      maxWidth: '100%',
      maxHeight: '100%',
      panelClass: 'custom-modal',
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  resetReciboImage() {
    this.reciboCompraImage = null;
    console.log(this.reciboCompraImage);
  }
  changeIris(event: any) {
    console.log(event);
    if (event === 0) {
      this.motivo = true;
    } else {
      this.motivo = false;
    }
  }

  openPhotoCaptureDialog() {
    const dialogRef = this.dialog.open(PhotoCaptureComponent, {
      data: {
        onlyPhoto: this.step === 1,
        multipleSelectionEnabled: this.step !== 1,
      },
      maxWidth: '100%',
      maxHeight: '100%',
      panelClass: 'custom-modal',
    });

    dialogRef
      .afterClosed()
      .subscribe(
        (result: { file: File; base64: string; type: 'photo' | 'video' }[]) => {
          console.log('Resultado del cuadro de diálogo:', result);
          console.log(`Step: ${this.step}`);

          if (result) {
            if (this.step === 1) {
              const image = result[0];
              this.reciboCompraImage = image.base64;
            } else if (this.step === 4) {
              for (const image of result) {
                this.adjuntos.push({
                  base64: image.base64,
                  type: image.type,
                  name:
                    image.type === 'video'
                      ? `Adjunto${this.adjuntos.length + 1}.webm`
                      : `Adjunto${this.adjuntos.length + 1}.jpeg`,
                });
              }
            }
          }
        }
      );
  }

  getDistribuidoresSubproyectos(proyecto: any) {
    this.ticketsSvc
      .getDistribuidoresSubproyectos(proyecto)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (v) => {
          console.log(v);
          this.distribuidoresSubproyectos = v;
          this.distribuidoresSubproyectosTemp = v;
        },
        error: (e) => {
          this.showSnackBarError(
            this.translocoService.translate('issue.error.loadDistributors')
          );
        },
      });
  }

  getCategoriesProyecto(proyecto: any) {
    this.ticketsSvc
      .getCategoriesProyecto(proyecto)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (v: any) => {
          console.log(v);
          this.categories = v;
        },
        error: (e) => {
          //Definir error con snack
        },
      });
  }

  getSymptonCodes(proyecto: any) {
    this.diagnosisService
      .getSymptonCodes(proyecto)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (v: any) => {
          console.log(v);
          this.symptonCodes = v;
        },
        error: (e) => {
          this.showSnackBarError(
            this.translocoService.translate('issue.error.loadSymptoms')
          );
        },
      });
  }

  getSectionCodes(proyecto: any) {
    this.diagnosisService
      .getSectionCodes(proyecto)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (v: any) => {
          console.log(v);
          this.sectionCodes = v;
        },
        error: (e) => {
          this.showSnackBarError(
            this.translocoService.translate('issue.error.loadSections')
          );
        },
      });
  }

  getUrlImageArticulo(imagen_id: any) {
    if (imagen_id) {
      console.log(
        environment.API_URL + '/almacenes/maestro-articulos/imagen/' + imagen_id
      );
      return (
        environment.API_URL + '/almacenes/maestro-articulos/imagen/' + imagen_id
      );
    } else return '/assets/default-image.jpg';
  }

  comprobarActivo() {
    const numserieTemp =
      this.formProducto.get('numserie1')?.value +
      '.' +
      this.formProducto.get('numserie2')?.value +
      '.' +
      this.formProducto.get('numserie3')?.value +
      '.' +
      this.formProducto.get('numserie4')?.value;

    console.log(numserieTemp);
    if (
      !this.formProducto.get('numserie1')?.value ||
      this.formProducto.get('numserie1')?.value === '' ||
      !this.formProducto.get('numserie2')?.value ||
      this.formProducto.get('numserie2')?.value === '' ||
      !this.formProducto.get('numserie3')?.value ||
      this.formProducto.get('numserie3')?.value === '' ||
      !this.formProducto.get('numserie4')?.value ||
      this.formProducto.get('numserie4')?.value === ''
    ) {
      this.showSnackBarError(
        this.translocoService.translate('issue.error.invalidSerial')
      );
    } else {
      this.ticketsSvc
        .comprobarActivo(numserieTemp)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (v) => {
            console.log('coincidencia: ', v);
            this.productoSelected = v.elemento;
            this.activoSelected = v;
          },
          error: (e) => {
            this.showSnackBarError(
              this.translocoService.translate('issue.error.serialNotFound')
            );
          },
        });
    }
  }

  navigateCasos() {
    this.router.navigate(['/casos']);
  }

  cerrarTicket() {
    this.ticketsSvc
      .changeStatusTicket(this.newTicket.ID, 'old_done')
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (v) => {
          console.log('change ticket: ', v);
          this.router.navigate(['/casos']);
        },
        error: (e) => {
          console.log(e);
          this.showSnackBarError(
            this.translocoService.translate('issue.error.closeTicket')
          );
        },
      });
  }

  getTicketsClienteHoy() {
    this.ticketsSvc
      .getTicketsClienteHoy(this.project, this.user?.cliente?.ID)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (response: any) => {
          console.log(response);
          console.log(response?.ticketsAbiertos?.length);
          if (response?.ticketsAbiertos?.length >= 3) {
            this.showSnackBarError(
              this.translocoService.translate('issue.error.dailyLimit')
            );
            this.router.navigate(['/casos']);
          }
        },
        error: (e) => {
          console.log(e);
          this.showSnackBarError(
            this.translocoService.translate('issue.error.loadTickets')
          );
        },
      });
  }

  goBack() {
    if (this.step === 1 && this.activoSelected && this.productoSelected) {
      this.activoSelected = null;
      this.productoSelected = null;
    } else if (
      this.step === 1 &&
      !this.activoSelected &&
      !this.productoSelected
    ) {
      this.router.navigate(['/casos']);
    } else if (this.step === 2) {
      this.step = 1;
      this.selectedSintoma = null;
    } else if (this.step === 3) {
      this.step = 2;
      this.selectedSection = null;
    } else if (this.step === 4) {
      this.step = 3;
    }
  }
}
